module.exports = __webpack_public_path__ + "img/originator-sunqianran.1c6b31f0.png";